import styles from '../../assets/styles/LandingPage/Faqs.module.scss';
import { MimaText, PageLoader } from '../../components';
import { GrFormAdd, GrFormSubtract } from 'react-icons/gr';
import React, { useState, useEffect } from 'react';
import Footer from './Footer';
import { supportStore } from '../../stores';
import { SupportController } from '../../controllers';
import Header3 from './Header3';
import { useMemo } from 'react';

const Faqs = () => {
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const getFaqsList = async () => {
            setLoading(true)
            await SupportController.faqCategories();
            setLoading(false)
        }
        getFaqsList();
    }, [])

    // const faqs = supportStore.faqs;
    const { faqs } = supportStore;

    const faqItems = useMemo(() => {
        return faqs.filter(x => {
            return x.faqs.length > 0
        })
    }, [faqs])

    const [answer, setAnswer] = useState(-1);
    const [data, setData] = useState(faqItems[0]);
    const [selected, setSelected] = useState(0)

    const showAnswer = i => {
        if (answer === i) {
            return setAnswer(-1);
        } else {
            setAnswer(i);
        }
    };

    return (
        <>
            <Header3 />

            <div className={styles.container}>
                <MimaText variant="h2" align="center" color="var(--color-dark)">FAQs</MimaText>
                <MimaText variant="bodyBold" align="center" mt={2} mb={4}>See answers to previously asked questions</MimaText>
                {loading ? <PageLoader loading={loading} /> : (
                    <div className={styles.container_faqs}>
                        <div>
                            <MimaText variant="bodyBold" mb={1}>Content</MimaText>
                            <div className={styles.nav}>
                                {faqItems?.map((item, index) => {
                                    return (
                                        <div
                                            className={selected === index ? styles.nav_item_active : styles.nav_item}
                                            onClick={() => {
                                                setData(item);
                                                setSelected(index);
                                            }}
                                            key={index}
                                        >
                                            {item.name}
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                        <div>
                            {data ? data?.faqs?.map((x, i) => {
                                return (
                                    <div
                                        key={i}
                                        className={styles.aside__ans}
                                    >
                                        <div
                                            className={answer === i ? styles.signs__active : styles.signs}
                                            onClick={() => {
                                                showAnswer(i)
                                            }}
                                        >
                                            <div className={styles.icon}>{answer === i ? <GrFormSubtract /> : <GrFormAdd />}</div>
                                            <div>{x?.question}</div>
                                        </div>
                                        {answer === i && <MimaText ml={3}>{x?.answer}</MimaText>}
                                    </div>

                                )
                            }) : null}
                        </div>
                    </div>
                )}
            </div>
            <Footer />
        </>
    );
};

export default Faqs;
